/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaselineParams } from '../models';
// @ts-ignore
import type { ListClusterAdoptionEventsResponse } from '../models';
// @ts-ignore
import type { RecalculateBaselineParamsRequestParams } from '../models';
// @ts-ignore
import type { RunClustersValueRealizationReportRequestFilter } from '../models';
// @ts-ignore
import type { RunClustersValueRealizationReportResponse } from '../models';
// @ts-ignore
import type { RunValueRealizationTimelineReportRequestFilter } from '../models';
// @ts-ignore
import type { RunValueRealizationTimelineReportResponse } from '../models';
// @ts-ignore
import type { RunWorkloadsValueRealizationReportRequestFilter } from '../models';
// @ts-ignore
import type { RunWorkloadsValueRealizationReportResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * ValueRealizationAPIApi - axios parameter creator
 * @export
 */
export const ValueRealizationAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get baseline parameters for a cluster\'s value realization calculations.
         * @summary Get cluster baseline parameters for value realization.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIGetBaselineParams: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('valueRealizationAPIGetBaselineParams', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('valueRealizationAPIGetBaselineParams', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/baseline-params`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists adoption transitions of CAST AI optimization components for one  cluster, in chronological order (oldest first), with day precision.
         * @summary List adoption events for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIListClusterAdoptionEvents: async (organizationId: string, clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('valueRealizationAPIListClusterAdoptionEvents', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('valueRealizationAPIListClusterAdoptionEvents', 'clusterId', clusterId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/adoption-events`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recalculate baseline parameters for cluster using custom date ranges.
         * @summary Recalculate baseline parameters for cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {RecalculateBaselineParamsRequestParams} recalculateBaselineParamsRequestParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIRecalculateBaselineParams: async (organizationId: string, clusterId: string, recalculateBaselineParamsRequestParams: RecalculateBaselineParamsRequestParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('valueRealizationAPIRecalculateBaselineParams', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('valueRealizationAPIRecalculateBaselineParams', 'clusterId', clusterId)
            // verify required parameter 'recalculateBaselineParamsRequestParams' is not null or undefined
            assertParamExists('valueRealizationAPIRecalculateBaselineParams', 'recalculateBaselineParamsRequestParams', recalculateBaselineParamsRequestParams)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/baseline-params:recalculate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recalculateBaselineParamsRequestParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate value realization report for all clusters in the organization with savings data and timeline breakdown.
         * @summary Get list of value realization clusters report.
         * @param {string} organizationId ID of the organization.
         * @param {RunClustersValueRealizationReportRequestFilter} runClustersValueRealizationReportRequestFilter 
         * @param {string} [startTime] Inclusive start of the interval.
         * @param {string} [endTime] Exclusive end of the interval.
         * @param {string} [timeZone] Optinal time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [useListingPrices] Use listing prices instead of discounted prices.
         * @param {boolean} [managedOnly] Whether node autoscaler savings should be restricted to Cast-managed nodes only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIRunClustersValueRealizationReport: async (organizationId: string, runClustersValueRealizationReportRequestFilter: RunClustersValueRealizationReportRequestFilter, startTime?: string, endTime?: string, timeZone?: string, pageLimit?: string, pageCursor?: string, useListingPrices?: boolean, managedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('valueRealizationAPIRunClustersValueRealizationReport', 'organizationId', organizationId)
            // verify required parameter 'runClustersValueRealizationReportRequestFilter' is not null or undefined
            assertParamExists('valueRealizationAPIRunClustersValueRealizationReport', 'runClustersValueRealizationReportRequestFilter', runClustersValueRealizationReportRequestFilter)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters:runValueRealizationReport`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (useListingPrices !== undefined) {
                localVarQueryParameter['useListingPrices'] = useListingPrices;
            }

            if (managedOnly !== undefined) {
                localVarQueryParameter['managedOnly'] = managedOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runClustersValueRealizationReportRequestFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Computes cost savings and resource efficiency across all clusters in the organization  with timeline breakdown showing actual vs projected costs over time.
         * @summary Returns organization value realization timeline report over time.
         * @param {string} id Organization ID for which to generate the report.
         * @param {RunValueRealizationTimelineReportRequestFilter} runValueRealizationTimelineReportRequestFilter 
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {string} [timeZone] Optinal time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {ValueRealizationAPIRunValueRealizationTimelineReportStepEnum} [step] Granularity of timeline data points.
         * @param {boolean} [useListingPrices] Use listing prices instead of discounted prices.
         * @param {boolean} [managedOnly] Whether node autoscaler savings should be restricted to Cast-managed nodes only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIRunValueRealizationTimelineReport: async (id: string, runValueRealizationTimelineReportRequestFilter: RunValueRealizationTimelineReportRequestFilter, startTime?: string, endTime?: string, timeZone?: string, step?: ValueRealizationAPIRunValueRealizationTimelineReportStepEnum, useListingPrices?: boolean, managedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('valueRealizationAPIRunValueRealizationTimelineReport', 'id', id)
            // verify required parameter 'runValueRealizationTimelineReportRequestFilter' is not null or undefined
            assertParamExists('valueRealizationAPIRunValueRealizationTimelineReport', 'runValueRealizationTimelineReportRequestFilter', runValueRealizationTimelineReportRequestFilter)
            const localVarPath = `/reporting/v1beta/organizations/{id}:runValueRealizationTimelineReport`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (step !== undefined) {
                localVarQueryParameter['step'] = step;
            }

            if (useListingPrices !== undefined) {
                localVarQueryParameter['useListingPrices'] = useListingPrices;
            }

            if (managedOnly !== undefined) {
                localVarQueryParameter['managedOnly'] = managedOnly;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runValueRealizationTimelineReportRequestFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generate per-workload value realization report showing WOOP optimization impact  for individual workloads within the specified date range.
         * @summary Get per-workload value realization report.
         * @param {string} organizationId ID of the organization.
         * @param {RunWorkloadsValueRealizationReportRequestFilter} runWorkloadsValueRealizationReportRequestFilter 
         * @param {string} [startTime] Inclusive start of the interval.
         * @param {string} [endTime] Exclusive end of the interval.
         * @param {string} [timeZone] Optional time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {boolean} [useListingPrices] Use listing prices instead of discounted prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIRunWorkloadsValueRealizationReport: async (organizationId: string, runWorkloadsValueRealizationReportRequestFilter: RunWorkloadsValueRealizationReportRequestFilter, startTime?: string, endTime?: string, timeZone?: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum, useListingPrices?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('valueRealizationAPIRunWorkloadsValueRealizationReport', 'organizationId', organizationId)
            // verify required parameter 'runWorkloadsValueRealizationReportRequestFilter' is not null or undefined
            assertParamExists('valueRealizationAPIRunWorkloadsValueRealizationReport', 'runWorkloadsValueRealizationReportRequestFilter', runWorkloadsValueRealizationReportRequestFilter)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/workloads:runValueRealizationReport`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (sortField !== undefined) {
                localVarQueryParameter['sort.field'] = sortField;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort.order'] = sortOrder;
            }

            if (useListingPrices !== undefined) {
                localVarQueryParameter['useListingPrices'] = useListingPrices;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runWorkloadsValueRealizationReportRequestFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update baseline parameters for a cluster\'s value realization calculations.
         * @summary Update cluster baseline parameters for value realization.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {BaselineParams} baselineParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIUpdateBaselineParams: async (organizationId: string, clusterId: string, baselineParams: BaselineParams, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('valueRealizationAPIUpdateBaselineParams', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('valueRealizationAPIUpdateBaselineParams', 'clusterId', clusterId)
            // verify required parameter 'baselineParams' is not null or undefined
            assertParamExists('valueRealizationAPIUpdateBaselineParams', 'baselineParams', baselineParams)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters/{clusterId}/baseline-params`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baselineParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ValueRealizationAPIApi - functional programming interface
 * @export
 */
export const ValueRealizationAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ValueRealizationAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Get baseline parameters for a cluster\'s value realization calculations.
         * @summary Get cluster baseline parameters for value realization.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueRealizationAPIGetBaselineParams(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaselineParams>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueRealizationAPIGetBaselineParams(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValueRealizationAPIApi.valueRealizationAPIGetBaselineParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists adoption transitions of CAST AI optimization components for one  cluster, in chronological order (oldest first), with day precision.
         * @summary List adoption events for a cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueRealizationAPIListClusterAdoptionEvents(organizationId: string, clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListClusterAdoptionEventsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueRealizationAPIListClusterAdoptionEvents(organizationId, clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValueRealizationAPIApi.valueRealizationAPIListClusterAdoptionEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Recalculate baseline parameters for cluster using custom date ranges.
         * @summary Recalculate baseline parameters for cluster.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {RecalculateBaselineParamsRequestParams} recalculateBaselineParamsRequestParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueRealizationAPIRecalculateBaselineParams(organizationId: string, clusterId: string, recalculateBaselineParamsRequestParams: RecalculateBaselineParamsRequestParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueRealizationAPIRecalculateBaselineParams(organizationId, clusterId, recalculateBaselineParamsRequestParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValueRealizationAPIApi.valueRealizationAPIRecalculateBaselineParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate value realization report for all clusters in the organization with savings data and timeline breakdown.
         * @summary Get list of value realization clusters report.
         * @param {string} organizationId ID of the organization.
         * @param {RunClustersValueRealizationReportRequestFilter} runClustersValueRealizationReportRequestFilter 
         * @param {string} [startTime] Inclusive start of the interval.
         * @param {string} [endTime] Exclusive end of the interval.
         * @param {string} [timeZone] Optinal time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {boolean} [useListingPrices] Use listing prices instead of discounted prices.
         * @param {boolean} [managedOnly] Whether node autoscaler savings should be restricted to Cast-managed nodes only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueRealizationAPIRunClustersValueRealizationReport(organizationId: string, runClustersValueRealizationReportRequestFilter: RunClustersValueRealizationReportRequestFilter, startTime?: string, endTime?: string, timeZone?: string, pageLimit?: string, pageCursor?: string, useListingPrices?: boolean, managedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunClustersValueRealizationReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueRealizationAPIRunClustersValueRealizationReport(organizationId, runClustersValueRealizationReportRequestFilter, startTime, endTime, timeZone, pageLimit, pageCursor, useListingPrices, managedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValueRealizationAPIApi.valueRealizationAPIRunClustersValueRealizationReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Computes cost savings and resource efficiency across all clusters in the organization  with timeline breakdown showing actual vs projected costs over time.
         * @summary Returns organization value realization timeline report over time.
         * @param {string} id Organization ID for which to generate the report.
         * @param {RunValueRealizationTimelineReportRequestFilter} runValueRealizationTimelineReportRequestFilter 
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {string} [timeZone] Optinal time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {ValueRealizationAPIRunValueRealizationTimelineReportStepEnum} [step] Granularity of timeline data points.
         * @param {boolean} [useListingPrices] Use listing prices instead of discounted prices.
         * @param {boolean} [managedOnly] Whether node autoscaler savings should be restricted to Cast-managed nodes only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueRealizationAPIRunValueRealizationTimelineReport(id: string, runValueRealizationTimelineReportRequestFilter: RunValueRealizationTimelineReportRequestFilter, startTime?: string, endTime?: string, timeZone?: string, step?: ValueRealizationAPIRunValueRealizationTimelineReportStepEnum, useListingPrices?: boolean, managedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunValueRealizationTimelineReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueRealizationAPIRunValueRealizationTimelineReport(id, runValueRealizationTimelineReportRequestFilter, startTime, endTime, timeZone, step, useListingPrices, managedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValueRealizationAPIApi.valueRealizationAPIRunValueRealizationTimelineReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generate per-workload value realization report showing WOOP optimization impact  for individual workloads within the specified date range.
         * @summary Get per-workload value realization report.
         * @param {string} organizationId ID of the organization.
         * @param {RunWorkloadsValueRealizationReportRequestFilter} runWorkloadsValueRealizationReportRequestFilter 
         * @param {string} [startTime] Inclusive start of the interval.
         * @param {string} [endTime] Exclusive end of the interval.
         * @param {string} [timeZone] Optional time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [sortField] The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
         * @param {ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum} [sortOrder] The order of returned items. Default is ASC.
         * @param {boolean} [useListingPrices] Use listing prices instead of discounted prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueRealizationAPIRunWorkloadsValueRealizationReport(organizationId: string, runWorkloadsValueRealizationReportRequestFilter: RunWorkloadsValueRealizationReportRequestFilter, startTime?: string, endTime?: string, timeZone?: string, pageLimit?: string, pageCursor?: string, sortField?: string, sortOrder?: ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum, useListingPrices?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunWorkloadsValueRealizationReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueRealizationAPIRunWorkloadsValueRealizationReport(organizationId, runWorkloadsValueRealizationReportRequestFilter, startTime, endTime, timeZone, pageLimit, pageCursor, sortField, sortOrder, useListingPrices, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValueRealizationAPIApi.valueRealizationAPIRunWorkloadsValueRealizationReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update baseline parameters for a cluster\'s value realization calculations.
         * @summary Update cluster baseline parameters for value realization.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {BaselineParams} baselineParams 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async valueRealizationAPIUpdateBaselineParams(organizationId: string, clusterId: string, baselineParams: BaselineParams, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaselineParams>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.valueRealizationAPIUpdateBaselineParams(organizationId, clusterId, baselineParams, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ValueRealizationAPIApi.valueRealizationAPIUpdateBaselineParams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ValueRealizationAPIApi - factory interface
 * @export
 */
export const ValueRealizationAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ValueRealizationAPIApiFp(configuration)
    return {
        /**
         * Get baseline parameters for a cluster\'s value realization calculations.
         * @summary Get cluster baseline parameters for value realization.
         * @param {ValueRealizationAPIApiValueRealizationAPIGetBaselineParamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIGetBaselineParams(requestParameters: ValueRealizationAPIApiValueRealizationAPIGetBaselineParamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BaselineParams> {
            return localVarFp.valueRealizationAPIGetBaselineParams(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists adoption transitions of CAST AI optimization components for one  cluster, in chronological order (oldest first), with day precision.
         * @summary List adoption events for a cluster.
         * @param {ValueRealizationAPIApiValueRealizationAPIListClusterAdoptionEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIListClusterAdoptionEvents(requestParameters: ValueRealizationAPIApiValueRealizationAPIListClusterAdoptionEventsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListClusterAdoptionEventsResponse> {
            return localVarFp.valueRealizationAPIListClusterAdoptionEvents(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * Recalculate baseline parameters for cluster using custom date ranges.
         * @summary Recalculate baseline parameters for cluster.
         * @param {ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIRecalculateBaselineParams(requestParameters: ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.valueRealizationAPIRecalculateBaselineParams(requestParameters.organizationId, requestParameters.clusterId, requestParameters.recalculateBaselineParamsRequestParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate value realization report for all clusters in the organization with savings data and timeline breakdown.
         * @summary Get list of value realization clusters report.
         * @param {ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIRunClustersValueRealizationReport(requestParameters: ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunClustersValueRealizationReportResponse> {
            return localVarFp.valueRealizationAPIRunClustersValueRealizationReport(requestParameters.organizationId, requestParameters.runClustersValueRealizationReportRequestFilter, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.useListingPrices, requestParameters.managedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Computes cost savings and resource efficiency across all clusters in the organization  with timeline breakdown showing actual vs projected costs over time.
         * @summary Returns organization value realization timeline report over time.
         * @param {ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIRunValueRealizationTimelineReport(requestParameters: ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunValueRealizationTimelineReportResponse> {
            return localVarFp.valueRealizationAPIRunValueRealizationTimelineReport(requestParameters.id, requestParameters.runValueRealizationTimelineReportRequestFilter, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.step, requestParameters.useListingPrices, requestParameters.managedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Generate per-workload value realization report showing WOOP optimization impact  for individual workloads within the specified date range.
         * @summary Get per-workload value realization report.
         * @param {ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIRunWorkloadsValueRealizationReport(requestParameters: ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunWorkloadsValueRealizationReportResponse> {
            return localVarFp.valueRealizationAPIRunWorkloadsValueRealizationReport(requestParameters.organizationId, requestParameters.runWorkloadsValueRealizationReportRequestFilter, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.useListingPrices, options).then((request) => request(axios, basePath));
        },
        /**
         * Update baseline parameters for a cluster\'s value realization calculations.
         * @summary Update cluster baseline parameters for value realization.
         * @param {ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParamsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        valueRealizationAPIUpdateBaselineParams(requestParameters: ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParamsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BaselineParams> {
            return localVarFp.valueRealizationAPIUpdateBaselineParams(requestParameters.organizationId, requestParameters.clusterId, requestParameters.baselineParams, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for valueRealizationAPIGetBaselineParams operation in ValueRealizationAPIApi.
 * @export
 * @interface ValueRealizationAPIApiValueRealizationAPIGetBaselineParamsRequest
 */
export interface ValueRealizationAPIApiValueRealizationAPIGetBaselineParamsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIGetBaselineParams
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIGetBaselineParams
     */
    readonly clusterId: string
}

/**
 * Request parameters for valueRealizationAPIListClusterAdoptionEvents operation in ValueRealizationAPIApi.
 * @export
 * @interface ValueRealizationAPIApiValueRealizationAPIListClusterAdoptionEventsRequest
 */
export interface ValueRealizationAPIApiValueRealizationAPIListClusterAdoptionEventsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIListClusterAdoptionEvents
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIListClusterAdoptionEvents
     */
    readonly clusterId: string
}

/**
 * Request parameters for valueRealizationAPIRecalculateBaselineParams operation in ValueRealizationAPIApi.
 * @export
 * @interface ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParamsRequest
 */
export interface ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParamsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParams
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParams
     */
    readonly clusterId: string

    /**
     * 
     * @type {RecalculateBaselineParamsRequestParams}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParams
     */
    readonly recalculateBaselineParamsRequestParams: RecalculateBaselineParamsRequestParams
}

/**
 * Request parameters for valueRealizationAPIRunClustersValueRealizationReport operation in ValueRealizationAPIApi.
 * @export
 * @interface ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReportRequest
 */
export interface ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReportRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly organizationId: string

    /**
     * 
     * @type {RunClustersValueRealizationReportRequestFilter}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly runClustersValueRealizationReportRequestFilter: RunClustersValueRealizationReportRequestFilter

    /**
     * Inclusive start of the interval.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly startTime?: string

    /**
     * Exclusive end of the interval.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly endTime?: string

    /**
     * Optinal time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly timeZone?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly pageCursor?: string

    /**
     * Use listing prices instead of discounted prices.
     * @type {boolean}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly useListingPrices?: boolean

    /**
     * Whether node autoscaler savings should be restricted to Cast-managed nodes only
     * @type {boolean}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReport
     */
    readonly managedOnly?: boolean
}

/**
 * Request parameters for valueRealizationAPIRunValueRealizationTimelineReport operation in ValueRealizationAPIApi.
 * @export
 * @interface ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReportRequest
 */
export interface ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReportRequest {
    /**
     * Organization ID for which to generate the report.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReport
     */
    readonly id: string

    /**
     * 
     * @type {RunValueRealizationTimelineReportRequestFilter}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReport
     */
    readonly runValueRealizationTimelineReportRequestFilter: RunValueRealizationTimelineReportRequestFilter

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReport
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReport
     */
    readonly endTime?: string

    /**
     * Optinal time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReport
     */
    readonly timeZone?: string

    /**
     * Granularity of timeline data points.
     * @type {'STEP_UNSPECIFIED' | 'ONE_DAY' | 'ONE_MONTH'}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReport
     */
    readonly step?: ValueRealizationAPIRunValueRealizationTimelineReportStepEnum

    /**
     * Use listing prices instead of discounted prices.
     * @type {boolean}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReport
     */
    readonly useListingPrices?: boolean

    /**
     * Whether node autoscaler savings should be restricted to Cast-managed nodes only
     * @type {boolean}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReport
     */
    readonly managedOnly?: boolean
}

/**
 * Request parameters for valueRealizationAPIRunWorkloadsValueRealizationReport operation in ValueRealizationAPIApi.
 * @export
 * @interface ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReportRequest
 */
export interface ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReportRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly organizationId: string

    /**
     * 
     * @type {RunWorkloadsValueRealizationReportRequestFilter}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly runWorkloadsValueRealizationReportRequestFilter: RunWorkloadsValueRealizationReportRequestFilter

    /**
     * Inclusive start of the interval.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly startTime?: string

    /**
     * Exclusive end of the interval.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly endTime?: string

    /**
     * Optional time_zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly timeZone?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly pageCursor?: string

    /**
     * The field name to order by. Nested fields can be specified by using a dot (e.g. user.name).
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly sortField?: string

    /**
     * The order of returned items. Default is ASC.
     * @type {'ASC' | 'asc' | 'DESC' | 'desc'}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly sortOrder?: ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum

    /**
     * Use listing prices instead of discounted prices.
     * @type {boolean}
     * @memberof ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReport
     */
    readonly useListingPrices?: boolean
}

/**
 * Request parameters for valueRealizationAPIUpdateBaselineParams operation in ValueRealizationAPIApi.
 * @export
 * @interface ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParamsRequest
 */
export interface ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParamsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParams
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParams
     */
    readonly clusterId: string

    /**
     * 
     * @type {BaselineParams}
     * @memberof ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParams
     */
    readonly baselineParams: BaselineParams
}

/**
 * ValueRealizationAPIApi - object-oriented interface
 * @export
 * @class ValueRealizationAPIApi
 * @extends {BaseAPI}
 */
export class ValueRealizationAPIApi extends BaseAPI {
    /**
     * Get baseline parameters for a cluster\'s value realization calculations.
     * @summary Get cluster baseline parameters for value realization.
     * @param {ValueRealizationAPIApiValueRealizationAPIGetBaselineParamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueRealizationAPIApi
     */
    public valueRealizationAPIGetBaselineParams(requestParameters: ValueRealizationAPIApiValueRealizationAPIGetBaselineParamsRequest, options?: RawAxiosRequestConfig) {
        return ValueRealizationAPIApiFp(this.configuration).valueRealizationAPIGetBaselineParams(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists adoption transitions of CAST AI optimization components for one  cluster, in chronological order (oldest first), with day precision.
     * @summary List adoption events for a cluster.
     * @param {ValueRealizationAPIApiValueRealizationAPIListClusterAdoptionEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueRealizationAPIApi
     */
    public valueRealizationAPIListClusterAdoptionEvents(requestParameters: ValueRealizationAPIApiValueRealizationAPIListClusterAdoptionEventsRequest, options?: RawAxiosRequestConfig) {
        return ValueRealizationAPIApiFp(this.configuration).valueRealizationAPIListClusterAdoptionEvents(requestParameters.organizationId, requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Recalculate baseline parameters for cluster using custom date ranges.
     * @summary Recalculate baseline parameters for cluster.
     * @param {ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueRealizationAPIApi
     */
    public valueRealizationAPIRecalculateBaselineParams(requestParameters: ValueRealizationAPIApiValueRealizationAPIRecalculateBaselineParamsRequest, options?: RawAxiosRequestConfig) {
        return ValueRealizationAPIApiFp(this.configuration).valueRealizationAPIRecalculateBaselineParams(requestParameters.organizationId, requestParameters.clusterId, requestParameters.recalculateBaselineParamsRequestParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate value realization report for all clusters in the organization with savings data and timeline breakdown.
     * @summary Get list of value realization clusters report.
     * @param {ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueRealizationAPIApi
     */
    public valueRealizationAPIRunClustersValueRealizationReport(requestParameters: ValueRealizationAPIApiValueRealizationAPIRunClustersValueRealizationReportRequest, options?: RawAxiosRequestConfig) {
        return ValueRealizationAPIApiFp(this.configuration).valueRealizationAPIRunClustersValueRealizationReport(requestParameters.organizationId, requestParameters.runClustersValueRealizationReportRequestFilter, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.useListingPrices, requestParameters.managedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Computes cost savings and resource efficiency across all clusters in the organization  with timeline breakdown showing actual vs projected costs over time.
     * @summary Returns organization value realization timeline report over time.
     * @param {ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueRealizationAPIApi
     */
    public valueRealizationAPIRunValueRealizationTimelineReport(requestParameters: ValueRealizationAPIApiValueRealizationAPIRunValueRealizationTimelineReportRequest, options?: RawAxiosRequestConfig) {
        return ValueRealizationAPIApiFp(this.configuration).valueRealizationAPIRunValueRealizationTimelineReport(requestParameters.id, requestParameters.runValueRealizationTimelineReportRequestFilter, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.step, requestParameters.useListingPrices, requestParameters.managedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generate per-workload value realization report showing WOOP optimization impact  for individual workloads within the specified date range.
     * @summary Get per-workload value realization report.
     * @param {ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueRealizationAPIApi
     */
    public valueRealizationAPIRunWorkloadsValueRealizationReport(requestParameters: ValueRealizationAPIApiValueRealizationAPIRunWorkloadsValueRealizationReportRequest, options?: RawAxiosRequestConfig) {
        return ValueRealizationAPIApiFp(this.configuration).valueRealizationAPIRunWorkloadsValueRealizationReport(requestParameters.organizationId, requestParameters.runWorkloadsValueRealizationReportRequestFilter, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.sortField, requestParameters.sortOrder, requestParameters.useListingPrices, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update baseline parameters for a cluster\'s value realization calculations.
     * @summary Update cluster baseline parameters for value realization.
     * @param {ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParamsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ValueRealizationAPIApi
     */
    public valueRealizationAPIUpdateBaselineParams(requestParameters: ValueRealizationAPIApiValueRealizationAPIUpdateBaselineParamsRequest, options?: RawAxiosRequestConfig) {
        return ValueRealizationAPIApiFp(this.configuration).valueRealizationAPIUpdateBaselineParams(requestParameters.organizationId, requestParameters.clusterId, requestParameters.baselineParams, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ValueRealizationAPIRunValueRealizationTimelineReportStepEnum = {
    STEP_UNSPECIFIED: 'STEP_UNSPECIFIED',
    ONE_DAY: 'ONE_DAY',
    ONE_MONTH: 'ONE_MONTH'
} as const;
export type ValueRealizationAPIRunValueRealizationTimelineReportStepEnum = typeof ValueRealizationAPIRunValueRealizationTimelineReportStepEnum[keyof typeof ValueRealizationAPIRunValueRealizationTimelineReportStepEnum];
/**
 * @export
 */
export const ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum = {
    ASC: 'ASC',
    asc: 'asc',
    DESC: 'DESC',
    desc: 'desc'
} as const;
export type ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum = typeof ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum[keyof typeof ValueRealizationAPIRunWorkloadsValueRealizationReportSortOrderEnum];
